export const expression = {
  error: {
    DIVISION_BY_ZERO:
      "A calculation error has occurred.<br />Division by zero is not possible.",
    NEGATIVE_SQRT_ROOT:
      "A calculation error has occurred.<br />The square root of a negative number is not possible.",
    INDETERMINATE_FORM:
      "A calculation error has occurred.<br />The result is undefined because the calculation has an indeterminate form.",
    INVALID_RESULT:
      "An error occurred while evaluating the calculation.<br />Please check the values you entered for the calculation.",
    NON_NUMERIC_VALUES:
      "A non-numeric field prevents the formula from being calculated correctly. Please contact the <HelpLink>STELAR Help Center</HelpLink> for assistance.",
    UNEXPECTED_ERROR:
      "There is an error in the mathematical formula. Please contact the <HelpLink>STELAR Help Center</HelpLink> for assistance.",
  },
  technicalDetails: "Technical details",
};
